import { useSearchParams } from "react-router";
import QuantityPicker from "../assets/QuantityPicker";
import selectProd from "../assets/selectProd";
import updateProd from "../assets/selectProds";
import scrollToTop from "../assets/scrollToTop";

const ProductComponent = (props) => {
    const { prod, steps, setSteps, setIsLoading, fProducts } = props;

    const [searchParams, setSearchParams] = useSearchParams();

    let step = steps.find(step => step.id === Number(searchParams.get('step')));

    const selectedProd = step?.data?.id === prod.id;

    let maximumCompatible = 4;

    if(step?.tag === 'ram') {
        maximumCompatible = steps.find(step => step.tag === 'mother')?.data?.features?.find(feature => feature.name === 'cantidad_slots_ram')?.value;
    } else if(step?.tag === 'disco') {
        if(prod.features?.find(feature => feature.name === 'tipo_ssd')?.value === 'm.2') {
            maximumCompatible = steps.find(step => step.tag === 'mother')?.data?.features?.find(feature => feature.name === 'cantidad_slots_m2')?.value;
        } else {
            maximumCompatible = steps.find(step => step.tag === 'mother')?.data?.features?.find(feature => feature.name === 'cantidad_sata')?.value;
        }
    }

    const handleBtn = (e) => {
        e.preventDefault();

        scrollToTop();

        if(step.data?.id === prod.id) {
            setIsLoading(true);

            setSteps(prevSteps => prevSteps.map(prevStep => prevStep.id === step.id ? {...prevStep, data: undefined} : prevStep))

            searchParams.delete(step.tag);
            return setSearchParams(searchParams, { replace: true });
        } else {
            selectProd(prod, searchParams, setSearchParams, step, setSteps);
        }
    }

    const onChange = (value, prevValue, maxValue) => {
        updateProd(value, maxValue, prod, step, setSteps, searchParams, setSearchParams, setIsLoading, prevValue, fProducts);
    }

    return (
        <div className={prod.compatible === false ? "product-container no-compatible" : "product-container"}>
            <div className="prodImg">
                {prod.is_outlet && <span className="outlet-badge">Outlet</span>}
                <img src={prod.image} alt={prod.name} />
                {(step?.multiple && prod.compatible !== false && (!step?.data || selectedProd)) && 
                    <QuantityPicker min={0} max={maximumCompatible || 4} value={(selectedProd && step.data.cantidad) || 0} onChange={onChange} />}
            </div>
            <div className="info">
                <h3 className="name">{prod.name}</h3>
                <p className="price">${new Intl.NumberFormat("es-AR", {minimumFractionDigits: 2}).format(
                    Number(prod.price).toFixed(2),
                )}</p> 
                    <span className={selectedProd ? "producto-compatibilidad compatible-selected" : "producto-compatibilidad"}>
                        <span className="compatibilidad-icon"></span>
                        {prod.compatible === false ? "No compatible" : selectedProd ? "Seleccionado" : "Compatible"}
                    </span>
                {(!step?.multiple) && 
                    <button className={selectedProd ? "select-prod selected" :"select-prod"} onClick={handleBtn} disabled={prod.compatible === false}>
                        {selectedProd ? "ELIMINAR" : "AGREGAR"}
                    </button>}
            </div>
        </div>
    )
}

export default ProductComponent;